/* tslint:disable */
/* eslint-disable */
/**
 * pinnacle-backend API spec
 * Backend Service for Pinnacle Underwriting | [swagger.json](pinnacle/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SubmissionCheckResponseDto
 */
export interface SubmissionCheckResponseDto {
    /**
     * 
     * @type {string}
     * @memberof SubmissionCheckResponseDto
     */
    result: SubmissionCheckResponseDtoResultEnum;
}


/**
 * @export
 */
export const SubmissionCheckResponseDtoResultEnum = {
    Passed: 'Passed',
    Failed: 'Failed',
    Partial: 'Partial'
} as const;
export type SubmissionCheckResponseDtoResultEnum = typeof SubmissionCheckResponseDtoResultEnum[keyof typeof SubmissionCheckResponseDtoResultEnum];


/**
 * Check if a given object implements the SubmissionCheckResponseDto interface.
 */
export function instanceOfSubmissionCheckResponseDto(value: object): value is SubmissionCheckResponseDto {
    if (!('result' in value) || value['result'] === undefined) return false;
    return true;
}

export function SubmissionCheckResponseDtoFromJSON(json: any): SubmissionCheckResponseDto {
    return SubmissionCheckResponseDtoFromJSONTyped(json, false);
}

export function SubmissionCheckResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): SubmissionCheckResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'result': json['result'],
    };
}

export function SubmissionCheckResponseDtoToJSON(json: any): SubmissionCheckResponseDto {
    return SubmissionCheckResponseDtoToJSONTyped(json, false);
}

export function SubmissionCheckResponseDtoToJSONTyped(value?: SubmissionCheckResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'result': value['result'],
    };
}

